import { useEffect, useState } from 'react';
import { PortalMobileShell } from './PortalMobileShell';
import { PortalDesktopShell } from './PortalDesktopShell';

const MOBILE_QUERY = '(max-width: 767px)';

function getIsMobileSurface() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia(MOBILE_QUERY).matches;
}

function useIsMobileSurface() {
  const [isMobile, setIsMobile] = useState(getIsMobileSurface);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }

    const query = window.matchMedia(MOBILE_QUERY);
    const handleChange = () => setIsMobile(query.matches);

    query.addEventListener('change', handleChange);
    handleChange();

    return () => query.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}

// Switches between the bottom-tab mobile shell and the sidebar desktop shell at the 767px breakpoint —
// the same split the clinic app uses (see apps/clinic/src/app/AppShell.tsx).
export function PortalShell() {
  const isMobile = useIsMobileSurface();

  return isMobile ? <PortalMobileShell /> : <PortalDesktopShell />;
}
